
import React, { useState, useContext, useEffect, useRef } from "react";


import * as XLSX from 'xlsx';
import MoondanceLayout from '../../lib/layout';
import Select from "react-select";
import Form from 'react-bootstrap/Form';
import { MoondanceContext } from '../../../App.js';
import UseMoondanceApi from "../../lib/api.js";
import { testurl, formatGroupLabel, groupAndSortPositions, buildAccountParameter, buildTransactionTypeList, formatOptionLabel, formatDate, } from "../../lib/formatData.js";
import {
  Card, Container, CardBody, Row, Col, InputGroup, Table, NavItem,
  NavLink, Nav, TabPane, TabContent, CardTitle, Button
} from "reactstrap";
import { use } from "react";
import ImportLib from './importLib.js';
function ImportXls() {
  const [currencyList, setCurrencyList] = useState([{ id: 'EUR', value: 'EUR', label: 'EUR' }, { id: 'USD', value: 'USD', label: 'USD' }, { id: 'GBP', value: 'GBP', label: 'GBP' }, { id: 'GBP', value: 'GBP', label: 'GBP' }]);
  const [transactionTypeList, setTransactionType] = useState(buildTransactionTypeList());
  const { addAlert } = useContext(MoondanceContext);
  const moondanceApi = UseMoondanceApi();
  const { accountList,setAccountList } = useContext(MoondanceContext);
  const { userCurrency, setUserCurrency } = useContext(MoondanceContext);
  const [fileName, setFileName] = useState('');
  const [sheetNames, setSheetNames] = useState([]);
  const [selectedSheet, setSelectedSheet] = useState(null);
  const [accountPositionList, setAccountPositionList] = useState([]);
  const [csvData, setCsvData] = useState('');
  const [showCsvFull, setShowCsvFull] = useState(false)
  const timestamp = Date.now();
  const { lastUpdate, setLastUpdate } = useContext(MoondanceContext);
  const flatpickrRef = useRef(null);
  const [positionList, setPositionList] = useState();
  const [showDuplicate, setShowDuplicate] = useState(false);
  const [showGuidelines, setShowGuidelines] = useState(false);
  const [formKeys, setFormKeys] = useState([]); // list of keys for the form

  const [showAddAccount, setShowAddAccount] = useState(0);
  const [userData, setUserData] = useState([]);
  const [newAccountName, setNewAccountName] = useState([]);


  const createNewAccount = async () => {
    if (newAccountName) {
      console.log(newAccountName)
      var requestData = {
        name: newAccountName
      }

      console.log(requestData)

      moondanceApi.createAccount(requestData).then(response => {
        console.log(response)
        if(response.success && response.account_id){
          setLastUpdate(timestamp);
          setSelectedAccount(response.account_id);
        } else {
          addAlert({ type: "danger", message: response.message });
         }
      }).catch(error => {
        console.log(error)
        return false
      });
    }
  }
  const formatOptionLabel = (option, { context }) => {
    if (context === "menu") {
      return (
        <div>
          <div>{option.label}</div>
          {option.description ? <div style={{ fontSize: '80%' }}>{option.description}</div> : null}
        </div>
      );
    }
    return <div>{option.label}</div>;
  };
  const [importType, setImportType] = useState('transaction');
  const [importTypeList] = useState(ImportLib.importTypeList);
  const [selectedAccount, setSelectedAccount] = useState(false);
  const [existingTransactions, setExistingTransactions] = useState([]);

  const dummyAiReply = {
    "success": true,
    "data": {
      "content": "```json\n{\n    \"success\": true,\n    \"transaction\": {\n        \"content\": [\n            {\n                \"date\": \"15/01/2025\",\n                \"position_id\": 30,\n                \"type\": \"setup_fee\",\n                \"value\": -225.10,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Frais de Private Banking\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"15/01/2025\",\n                \"position_id\": 0,\n                \"type\": \"setup_fee\",\n                \"value\": -440.85,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Commission de conseil\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"31/12/2024\",\n                \"position_id\": 0,\n                \"type\": null,\n                \"value\": 69.77,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Intérêts créditeurs\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"31/12/2024\",\n                \"position_id\": 0,\n                \"type\": null,\n                \"value\": -20.93,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Précompte mobilier\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"30/12/2024\",\n                \"position_id\": 7,\n                \"type\": \"distribution\",\n                \"value\": 216.58,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Distribution DIV ZEPHYR'07 PRIV EQ CO\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"30/12/2024\",\n                \"position_id\": 7,\n                \"type\": \"distribution\",\n                \"value\": 8229.75,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Distribution CAP ZEPHYR'07 PRIV EQ CO\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"30/12/2024\",\n                \"position_id\": 7,\n                \"type\": \"distribution\",\n                \"value\": 4640.23,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Distribution CAD ZEPHYR'07 PRIV EQ CO\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"30/12/2024\",\n                \"position_id\": 7,\n                \"type\": \"setup_fee\",\n                \"value\": -95.80,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Management Fees ZEPHYR'07 PRIV EQ COM\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"30/12/2024\",\n                \"position_id\": 7,\n                \"type\": \"capital_call\",\n                \"value\": -293.18,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Capital Call ZEPHYR'07 PRIV EQ COMMIT\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"30/12/2024\",\n                \"position_id\": 7,\n                \"type\": \"capital_call\",\n                \"value\": -3447.90,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Capital Call ZEPHYR'07 PRIV EQ COMMIT\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"29/11/2024\",\n                \"position_id\": 0,\n                \"type\": null,\n                \"value\": -69.77,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Ext. int courus au 30/11/24\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"29/11/2024\",\n                \"position_id\": 0,\n                \"type\": null,\n                \"value\": 69.77,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Int courus au 30/11/24\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"08/11/2024\",\n                \"position_id\": 0,\n                \"type\": null,\n                \"value\": -105000.00,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Virement à B0120950\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"31/10/2024\",\n                \"position_id\": 0,\n                \"type\": null,\n                \"value\": -32.56,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Ext. int courus au 31/10/24\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"31/10/2024\",\n                \"position_id\": 0,\n                \"type\": null,\n                \"value\": 32.56,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Int courus au 31/10/24\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"14/10/2024\",\n                \"position_id\": 0,\n                \"type\": \"setup_fee\",\n                \"value\": -262.98,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Frais de Private Banking\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"14/10/2024\",\n                \"position_id\": 0,\n                \"type\": \"setup_fee\",\n                \"value\": -543.79,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Commission de conseil\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"30/09/2024\",\n                \"position_id\": 138,\n                \"type\": \"recalled_distributions\",\n                \"value\": 105221.90,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Rbt 300 PARTNERS GRP GL VAL R EUR\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"27/08/2024\",\n                \"position_id\": 7,\n                \"type\": \"distribution\",\n                \"value\": 105.18,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Distribution DIV ZEPHYR'07 PRIV EQ CO\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"27/08/2024\",\n                \"position_id\": 7,\n                \"type\": \"distribution\",\n                \"value\": 4363.06,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Distribution CAD ZEPHYR'07 PRIV EQ CO\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"27/08/2024\",\n                \"position_id\": 7,\n                \"type\": \"distribution\",\n                \"value\": 1176.82,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Distribution CAP ZEPHYR'07 PRIV EQ CO\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"27/08/2024\",\n                \"position_id\": 7,\n                \"type\": \"setup_fee\",\n                \"value\": -313.14,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Management Fees ZEPHYR'07 PRIV EQ COM\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"27/08/2024\",\n                \"position_id\": 7,\n                \"type\": \"capital_call\",\n                \"value\": -3141.05,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Capital Call ZEPHYR'07 PRIV EQ COMMIT\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"25/07/2024\",\n                \"position_id\": 7,\n                \"type\": \"distribution\",\n                \"value\": 140.36,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Distribution DIV ZEPHYR'07 PRIV EQ CO\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"25/07/2024\",\n                \"position_id\": 7,\n                \"type\": \"distribution\",\n                \"value\": 2149.21,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Distribution CAD ZEPHYR'07 PRIV EQ CO\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"25/07/2024\",\n                \"position_id\": 7,\n                \"type\": \"distribution\",\n                \"value\": 613.65,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Distribution CAP ZEPHYR'07 PRIV EQ CO\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"25/07/2024\",\n                \"position_id\": 7,\n                \"type\": \"capital_call\",\n                \"value\": -13.23,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Capital Call ZEPHYR'07 PRIV EQ COMMIT\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"25/07/2024\",\n                \"position_id\": 7,\n                \"type\": \"capital_call\",\n                \"value\": -265.38,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Capital Call ZEPHYR'07 PRIV EQ COMMIT\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"19/07/2024\",\n                \"position_id\": 0,\n                \"type\": \"setup_fee\",\n                \"value\": -253.39,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Frais de Private Banking\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"19/07/2024\",\n                \"position_id\": 0,\n                \"type\": \"setup_fee\",\n                \"value\": -488.91,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Commission de conseil\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"09/07/2024\",\n                \"position_id\": 7,\n                \"type\": \"distribution\",\n                \"value\": 449.29,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Distribution DIV ZEPHYR'07 PRIV EQ CO\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"09/07/2024\",\n                \"position_id\": 7,\n                \"type\": \"distribution\",\n                \"value\": 7137.84,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Distribution CAP ZEPHYR'07 PRIV EQ CO\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"09/07/2024\",\n                \"position_id\": 7,\n                \"type\": \"distribution\",\n                \"value\": 4256.66,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Distribution CAD ZEPHYR'07 PRIV EQ CO\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"09/07/2024\",\n                \"position_id\": 7,\n                \"type\": \"capital_call\",\n                \"value\": -373.74,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Capital Call ZEPHYR'07 PRIV EQ COMMIT\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"09/07/2024\",\n                \"position_id\": 7,\n                \"type\": \"capital_call\",\n                \"value\": -413.61,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Capital Call ZEPHYR'07 PRIV EQ COMMIT\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"09/07/2024\",\n                \"position_id\": 7,\n                \"type\": \"capital_call\",\n                \"value\": -6055.44,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Capital Call ZEPHYR'07 PRIV EQ COMMIT\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"12/06/2024\",\n                \"position_id\": 0,\n                \"type\": null,\n                \"value\": 6688.70,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Virement de B0120901\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"06/06/2024\",\n                \"position_id\": 17,\n                \"type\": \"capital_call\",\n                \"value\": -20000.00,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Capital Call BLACKROCK PRIV EQ COMMIT\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"23/04/2024\",\n                \"position_id\": 0,\n                \"type\": \"setup_fee\",\n                \"value\": -254.04,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Frais de Private Banking\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"23/04/2024\",\n                \"position_id\": 0,\n                \"type\": \"setup_fee\",\n                \"value\": -423.26,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Commission de conseil\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"07/02/2024\",\n                \"position_id\": 7,\n                \"type\": \"distribution\",\n                \"value\": 357.20,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Distribution DIV ZEPHYR'07 PRIV EQ CO\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"07/02/2024\",\n                \"position_id\": 7,\n                \"type\": \"distribution\",\n                \"value\": 5771.91,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Distribution CAP ZEPHYR'07 PRIV EQ CO\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"07/02/2024\",\n                \"position_id\": 7,\n                \"type\": \"distribution\",\n                \"value\": 1456.71,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Distribution CAD ZEPHYR'07 PRIV EQ CO\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"07/02/2024\",\n                \"position_id\": 7,\n                \"type\": \"capital_call\",\n                \"value\": -355.95,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Capital Call ZEPHYR'07 PRIV EQ COMMIT\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"07/02/2024\",\n                \"position_id\": 7,\n                \"type\": \"capital_call\",\n                \"value\": -415.86,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Capital Call ZEPHYR'07 PRIV EQ COMMIT\",\n                \"comment\": \"\"\n            },\n            {\n                \"date\": \"07/02/2024\",\n                \"position_id\": 7,\n                \"type\": \"capital_call\",\n                \"value\": -3106.55,\n                \"shares\": 0,\n                \"currency\": \"EUR\",\n                \"bank\": \"\",\n                \"note\": \"Capital Call ZEPHYR'07 PRIV EQ COMMIT\",\n                \"comment\": \"\"\n            }\n        ],\n        \"comment\": \"\"\n    },\n    \"cost\": 0\n}\n```",
      "refusal": null,
      "role": "assistant",
      "audio": null,
      "function_call": null,
      "tool_calls": null
    },
    "nt": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiZW1haWwiOiJndXkuY291cGV6QHByb3Rvbm1haWwuY29tIiwicGhvbmUiOiIzMjQ3NjU3MjY4OSIsImV4cCI6MTczOTg3NTMyMCwidGltZXN0YW1wIjoxNzM5ODcxNzIwLCJzYWx0Ijoibm5kdTVmc2J2am1jcXhhMHh1dmI3OGVnIn0.yk27w8cz45Gc5yvyG3JdLaLgM-KmMmEBg57J2VxbyPs"
  }
  ////////////////////////////////////////////////////////////////////////////////////////// 
  /* HANDLE FILE IMPORT */
  //////////////////////////////////////////////////////////////////////////////////////////
  const [xlsFileContent, setXlsFileContent] = useState();
  const [jsonData, setJsonData] = useState([]);

  //trigger file input
  const handleButtonClick = () => {
    document.getElementById('fileInput').click();
  };
  // handle file change
  const handleFileChange = async (event) => {
    // Reset the file content
    setXlsFileContent(null);
    setCsvData([]);
    setJsonData([]);
    setSheetNames([]);
    setSelectedSheet(null);

    const file = event.target.files[0];
    if (!file) {
      console.warn("No file selected.");
      return;
    }
    setFileName(file.name);
    try {
      const workbook = await ImportLib.handleFile(event);
      setXlsFileContent(workbook);
      if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
        console.error("Invalid workbook structure.");
        return;
      }
      setSheetNames(workbook.SheetNames);
      if (workbook.SheetNames.length === 1) {
        setSelectedSheet(workbook.SheetNames[0]);
      }
    } catch (error) {
      console.error("Error processing file:", error);
    }
  };
  //handle sheet selection
  const handleSheetSelection = (id) => {
    setJsonData([]);
    setFormData([]);
    setSelectedSheet(xlsFileContent.SheetNames[id]);

  };
  //Reload file when file content of selected sheet changes
  useEffect(() => {
    // Prevent running if xlsFileContent or selectedSheet is not set
    if (!xlsFileContent || !selectedSheet) return;
    const loadSheetData = async () => {
      try {
        const newCsvData = await ImportLib.loadXlsSheet(xlsFileContent, selectedSheet, "csv");
        setCsvData(newCsvData || "");

        const newJsonData = await ImportLib.loadXlsSheet(xlsFileContent, selectedSheet, "json");
        setJsonData(newJsonData || []);
      } catch (error) {
        console.error("Error processing file:", error);
      }
    };
    loadSheetData(); // Call the async function
  }, [selectedSheet, xlsFileContent]); // Runs when selectedSheet or xlsFileContent changes
  //get  the right keys depedning on the import type
  useEffect(() => {
    const keys = (importType ? ImportLib.importTypeList.find(item => item.id == importType).keys : []);
    if (keys && keys.length > 0 && keys !== formKeys) {
      setFormKeys(keys)
    }
  }, [ImportLib.importTypeList, importType])

  function setDefaultKeyMap() {
    const keys = (importType ? ImportLib.importTypeList.find(item => item.id == importType).keys : []);
    let newKeyMap = {}
    let keyOrder = 0
    Object.keys(keys).forEach(key => {
      newKeyMap[key] = {};
      newKeyMap[key]['col'] = keyOrder;
      newKeyMap[key]['format'] = keys[key].type;
      keyOrder++;
    }
    );
    return newKeyMap


  }
  ////////////////////////////////////////////////////////////////////////////////////////// 
  /* ANALYSE FILE */
  ////////////////////////////////////////////////////////////////////////////////////////// 
  // Launch the analysis of the data extracted from the file when the data is loaded
  const [keyMap, setKeyMap] = useState(setDefaultKeyMap());
  useEffect(() => {
    if (selectedSheet && jsonData && jsonData.length > 0 && importType) {
      preAnalyseXlsFile(jsonData[0])
    }
  }, [jsonData, importType, selectedSheet])

  //Analyse data , Check if importType keys are found in extracted data
  const [missingKeys, setMissingKeys] = useState([]);
  function preAnalyseXlsFile(data) {
    //check if we find required keys 
    const keys = (importType ? ImportLib.importTypeList.find(item => item.id == importType).keys : []);
    setFormKeys(keys)
    let newKeyMap = {}
    newKeyMap._found = [];
    //By default, keys are not found
    Object.keys(keys).forEach(key => {
      newKeyMap[key] = {};
      newKeyMap[key]['col'] = false;
      newKeyMap[key]['format'] = false;

    });
    //check 1st row of data
    data.forEach((item, index) => {
      // Normalize item to lowercase for case-insensitive comparison
      const normalizedItem = item.trim().toLowerCase();
      // Iterate through each key in the keys object
      for (const key in keys) {
        // Check if the primary key label matches (case-insensitive)
        newKeyMap[key]['id'] = key;
        if (normalizedItem === keys[key].label.toLowerCase()) {
          newKeyMap[key]['col'] = index;
          newKeyMap[key]['format'] = keys[key].type;
          newKeyMap._found[index] = key;
          break;
        }
        if (normalizedItem === key) {
          newKeyMap[key]['col'] = index;
          newKeyMap[key]['format'] = keys[key].type;
          newKeyMap._found[index] = key;
          break;
        }
        // Check if any alternate labels match (case-insensitive)
        if (keys[key].alternate.some(alt => normalizedItem === alt.toLowerCase())) {
          newKeyMap[key]['col'] = index;
          newKeyMap[key]['format'] = keys[key].type;
          newKeyMap._found[index] = key;
          break;
        }
      }
    });
    console.log('newKeyMap', newKeyMap)
    setKeyMap(newKeyMap)
    //check if all required keys are present, list missing keys
    let missingKeys = Object.keys(keys)
      .filter(key => keys[key].required && newKeyMap[key].col === false)
      .map(key => ({
        key: key,
        explanation: keys[key].explanation,
      }));
    //console.log('missingKeys', formKeys, newKeyMap, missingKeys)
    setMissingKeys(missingKeys)
  }
  // when key are stored and data avalaible, Build the array from the extracted data, to be used in the form
  useEffect(() => {
    if (keyMap && jsonData && jsonData.length > 0) {

      console.log('buildArrayFromXlsData', keyMap, jsonData)
      buildArrayFromXlsData()
    }
  }, [keyMap, jsonData, selectedSheet,importType,selectedAccount])
  const [formData, setFormData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  //Build the array from the extracted data, to be used in the form
  function buildArrayFromXlsData() {
    setShowForm(false)
    let newArray = []
    jsonData.map((row, index) => {
      let newRow = {}
      Object.keys(keyMap).map((key) => {
        if (keyMap[key].format && keyMap[key].format === 'dateString') {
          newRow[key] = (row[keyMap[key].col] ? MoondanceLayout.convertToDateString(row[keyMap[key].col], 'xls') : null)
        } else {
          newRow[key] = (row[keyMap[key].col] ? row[keyMap[key].col] : null)
        }
      })
      newRow['_edit_status'] = 'unsaved'
      let rowCheck = checkRow(newRow)
      newRow['_valid'] = rowCheck[0]
      newRow['_invalidKeys'] = rowCheck[1]
      newRow['_duplicate'] = checkDuplicate(newRow)
      console.log('newRow', importType,newRow)
      newArray.push(newRow)
    })
    setFormData(newArray)

  }
  useEffect(() => {
    if (formData && formData.length > 0) {
      setShowForm(true)
    }

  }, [formData])
  //////////////////////////////////////////////////////////////////////////////////////////
  /* CHECK ROW */
  //////////////////////////////////////////////////////////////////////////////////////////
  // Check if the row is valid
  function checkRow(thisRow) {
    let valid = true;
    let invalidKeys = [];
    Object.values(keyMap).forEach((key) => {

      //console.log('checkRow', key, thisRow)
      const value = (thisRow[key.id] ? thisRow[key.id] : undefined);



      if (formKeys[key.id] && formKeys[key.id].required && (value === undefined || value === '')) {
        // console.log('Missing required key:', key);
        invalidKeys[key.id] = true;
        valid = false;
      }

      // Check if value matches the expected type
      if (value && value !== undefined && keyMap[key.id] && keyMap[key.id].format) {
        if (!MoondanceLayout.isValidType(value, keyMap[key.id].format)) {
          // console.log(`Type mismatch for key '${key.id}': expected ${keyMap[key.id].format}, got ${typeof value}`, value);
          invalidKeys[key.id] = true;
          valid = false;
        }
      }
      //check if value is in the available options
      if (value && value !== undefined && keyMap[key.id] && keyMap[key.id].options) {
        if (!keyMap[key.id].options.includes(value)) {
          console.log(`Type mismatch for key '${key.id}': expected ${keyMap[key.id].format}, got ${typeof value}`, value);
          invalidKeys[key.id] = true;
          valid = false;
        }
      }


    });

    if (importType === 'transaction' && thisRow.type && thisRow.value) {
      var matchingRowthisTransactionType = MoondanceLayout.transactionType.find(item => item.value === thisRow.type);
      //console.log('matchingRowthisTransactionType', matchingRowthisTransactionType, thisRow.value)

      if (matchingRowthisTransactionType && matchingRowthisTransactionType.sign === '-' && thisRow.value > 0) {
        console.log('matchingRowthisTransactionType', matchingRowthisTransactionType, thisRow.value)
        invalidKeys['value'] = true;
        valid = false;
      }
    } else if (matchingRowthisTransactionType && matchingRowthisTransactionType.sign === '+' && thisRow.value < 0) {
      // console.log('matchingRowthisTransactionType', matchingRowthisTransactionType, thisRow.value)

      invalidKeys['value'] = true;
      valid = false;
    }
    return [valid, invalidKeys];
  }
  //////////////////////////////////////////////////////////////////////////////////////////
  /* Load existing data */
  //////////////////////////////////////////////////////////////////////////////////////////
  //LOAD EXISTING DATA To find duplicate and helpo AI to identify misisng ids
  useEffect(() => {
    if (selectedAccount && formKeys ) {
      fetch_account_position_list()
    }
    if (importType === 'transaction' && selectedAccount) {
      load_transaction();
    }
  }, [selectedAccount, importType, formKeys]);
  //Load transactions
  async function load_transaction() {
    //console.log('load_transaction', selectedAccount)
    var api_parameters = {
      account: selectedAccount,
      userCurrency: userCurrency,
      date_start: '1900-01-01',
      date_end: '2100-01-01',
      status: 'All',
      keyword: ''
    }
    var data_transactions = await moondanceApi.fetchTransactions(api_parameters);
    if (data_transactions.success && data_transactions.data.length > 0) {
      setExistingTransactions(data_transactions.data)
    } else {
      setExistingTransactions([])
    }

  }
  //Load positions
  async function fetch_account_position_list() {
    var api_parameters = {
      account: selectedAccount,
      status: 'All',
      userCurrency: userCurrency,
    }
    let newFormKeys = formKeys

    try {
      const response = await moondanceApi.fetchPositionsList(api_parameters)
      if (response.data.length > 0) {
        setAccountPositionList(response.data)
        let filteredPositionList = response.data.filter(item => item.user_can_add_transaction === 1)
        let positionList = groupAndSortPositions(filteredPositionList)  ///SECURITY
        setPositionList(positionList)

        if (formKeys['position_id']) {
          let positionListOptions = []
          console.log('filteredPositionList', filteredPositionList)
          filteredPositionList.map((item) => {
            item.label = item.asset_name + ' (pos ID =' + item.position_id + ' - ' + item.asset_feeder_name + ')'
            item.value = item.position_id
            item.id = item.position_id
            positionListOptions.push(item)
          })

          newFormKeys['position_id']['options'] = positionListOptions
        }

        if (formKeys['asset_id']) {
          let filteredAssetList = response.data.filter(item => item.user_can_add_transaction === 1)
          let assetListOptions = []
          filteredAssetList.map((item) => {
            item.label = item.asset_name + ' (asste ID :' + item.asset_id + ' - ' + item.asset_feeder_name + ')'
            item.value = item.asset_id
            item.id = item.asset_id
            assetListOptions.push(item)
          })
          newFormKeys['asset_id']['options'] = assetListOptions
        }



        console.log('newFormKeys', newFormKeys)
        setFormKeys(newFormKeys)
        //console.log('positionListOptions', positionListOptions)
        return response.data
      } else {
        return []
      }
    } catch (error) {
      console.log(error);
      return []
    }
    return []
  }
  //////////////////////////////////////////////////////////////////////////////////////////
  /* AI Analysis */
  //////////////////////////////////////////////////////////////////////////////////////////
  const [aiLoading, setAiLoading] = useState('');
  const [aiReply, setAiReply] = useState('');
  const [aiPrompt, setAiPrompt] = useState('');
  const [aiReturnedData, setAiReturnedData] = useState([]);
  const [aiReturnedComment, setAiReturnedComment] = useState('');
  //AI part
  async function analyse_ai() {
    // Reset the AI reply and loading state
    setAiReturnedData([]);
    setAiLoading(<><span className="spinner-border text-primary" style={{ height: '1em', width: '1em', marginRight: '1em' }} role="status"></span> Waiting for AI to analyse your data ... it might take a few minutes</>);

    // Prepare the AI prompt
    let prompt = importTypeList.find(item => item.id == importType).prompt;

    if (importType == 'transaction') {
      let promptPositionList = `
      Guideline for AI regarding position_id :
      - Ensure that when extracting positions, the **position_name** or **asset_feeder_name** must be matched to a rule in the following list.  
    
      - The position ID **must** follow these rules exactly:
      name;feeder_name;position_id
      `;
      accountPositionList.forEach((item) => {
        promptPositionList += item.asset_name + ', ' + item.asset_feeder_name + ';' + item.position_id + '\n';
      });
      prompt += promptPositionList
      prompt += `
      - For any item  with no matching position name, default to position_id = null.
      - Always check for both **positionName** and **feederName** when determining the position ID.
      `;
    }

    prompt += 'Data to analyse (csv):\n' + csvData
    setAiPrompt(prompt);
    console.log('prompt', JSON.stringify(prompt))
    try {
      // Convert the data to JSON format
      const startTime = Date.now();
      let response = await moondanceApi.ai_analyse({ prompt: prompt });
      // Ensure response is not undefined or null before checking its length
      if (response && response.data && response.data.content) {
        const endTime = Date.now();
        const elapsedSeconds = Math.round((endTime - startTime) / 1000);
        setAiLoading('Result obtained in ' + elapsedSeconds + ' seconds');
        let result = manageAiResult(response)
        setFormData(result);
        setAiReturnedComment('No data returned from AI');
        setAiLoading('');
      }
    } catch (error) {
      console.log('AI Response', error)
      setAiReturnedComment('AI is not responding or responding with an error :' + error);
      console.log(error);
    } finally {
      // Ensure loading state is reset
    }
  }
  function manageAiResult(result) {
    setKeyMap(setDefaultKeyMap())

    try {
      // Extract and sanitize content from dummyAiReply
      console.log('manageAiTransactionResult', result)
      let content = result.data?.content ? result.data.content : '';


      // Parse the JSON content safely
      let jsonContent;
      try {
        content = content.replace(/```json|```/g, "").replace(/[\r\n\t]+/g, ' ').trim();
        jsonContent = JSON.parse(content);
      } catch (error) {
        console.error("Failed to parse JSON content:", error);
        return;
      }


      console.log('jsonContent', jsonContent)
      // Extract and clean transaction data from JSON

      let contentArray = ''
      // Convert CSV content to an array of objects
      if (importType == 'transaction') {
        contentArray = (jsonContent && jsonContent.transaction && jsonContent.transaction.content && jsonContent.transaction.content.length) ? jsonContent.transaction.content : [];

        setAiReturnedComment(jsonContent.transaction.comment || '');
      } else if (importType == 'position') {

        contentArray = (jsonContent && jsonContent.position && jsonContent.position.content && jsonContent.position.content.length) ? jsonContent.position.content : [];
        setAiReturnedComment('');
      }

      if (!contentArray.length) {
        console.warn("No valid item found in CSV content.");
        return;
      }


      contentArray.forEach((item, index) => {

        let rowCheck = checkRow(contentArray[index])
        contentArray[index]._edit_status = 'unsaved';
        contentArray[index]._valid = rowCheck[0]
        contentArray[index]._invalidKeys = rowCheck[1]
        contentArray[index]._duplicate = checkDuplicate(contentArray[index])


      });

      // Update application state with processed data
      setAiReturnedData(contentArray);
      return contentArray;
      ;
    } catch (error) {
      console.error("An unexpected error occurred:", error);
      return false;
    }
  }
  function testWithDummyData() {
    setAiLoading('loading dummy data ..');
    let result = manageAiResult(dummyAiReply)
    setFormData(result);
    setShowForm(true)


  }
  //////////////////////////////////////////////////////////////////////////////////////////
  //EDIT Form PArt

  // Handle form change
  function handle_form_change(key, index, newValue) {
    // console.log('handle_form_change', key, index, newValue)
    let newFormData = [...formData]
    let thisRow = formData[index]
    thisRow[key] = newValue
    let rowCheck = checkRow(thisRow)
    newFormData[index][key] = newValue
    newFormData[index]._valid = rowCheck[0]
    newFormData[index]._invalidKeys = rowCheck[1]
    if (key !== '_edit_status') { newFormData[index]._edit_status = 'unsaved'; }
    newFormData[index]._duplicate = checkDuplicate(newFormData)
    setFormData(newFormData);

  }
  // Check if the row is a duplicate
  function checkDuplicate(thisRow) {
    let duplicateRow = null;
    if (importType == 'transaction') {
      duplicateRow = existingTransactions.find(row =>
        row.date === thisRow.date &&
        parseInt(row.position_id) === parseInt(thisRow.position_id) &&
        parseFloat(row.value_in_transaction_currency) === parseFloat(thisRow.value) &&
        row.type === thisRow.type
      );
    } else if (importType == 'position') {
      console.log('accountPositionList', accountPositionList,thisRow)
      duplicateRow = accountPositionList.find(row =>
        row.asset_name === thisRow.name ||
        (row.asset_feeder_name  !=='' && row.asset_feeder_name === thisRow.feederName)
      );
      return duplicateRow && duplicateRow.position_id  ? duplicateRow.position_id : null;
    }
    // Return the ID of the matching row if found, or null if no match
    return duplicateRow ? duplicateRow.id : null;
  }


  //hande click on saveRow button
  function saveRow(thisRow, index) {
    if (importType === 'transaction') {
      saveTransactionRow(thisRow, index)
    } else if (importType === 'position') {
      savePositionRow(thisRow, index)
    } else if (importType === 'nav') {
      saveNavRow(thisRow, index)
    }
  }


  function saveNavRow(thisRow, index) {
    console.log(accountPositionList)
    if (!thisRow.shares) { thisRow.shares = 0 }
    var parts = thisRow.date.split('/');
    var newDateStr = `${parts[2]}-${parts[1]}-${parts[0]}`;

    let requestData = {
      position_id: thisRow.position_id,
      nav: thisRow.value,
      date: newDateStr,
      shares: thisRow.shares
    }
    let thisPosition = accountPositionList.find(item => item.position_id === thisRow.position_id)
    if (thisPosition.currency) {
      requestData.currency = thisPosition.currency
    } else {
      requestData.currency = userCurrency
    }
    moondanceApi.postNav(requestData).then(response => {
      if (response.success) {
        addAlert({
          status: 'success',
          title: 'Update NAV',
          message: 'Net Asset Value has been updated for position ' + requestData.position_id + ' !'
        })
        handle_form_change('_edit_status', index, 'saved')
        setLastUpdate(timestamp)
      } else {
        addAlert({
          status: 'danger',
          title: 'Failed to update Net Asset Value for Position:' + requestData.position_id,
          message: (response.error ? response.error : 'An error occured')
        })
      }
    })
      .catch(error => {
        addAlert({
          status: 'danger',
          title: 'Failed to update Net Asset Value for Position:' + requestData.position_id,
          message: error
        })
      });


  }



  // Save  a transaction row
  function saveTransactionRow(thisRow, index) {
    if (!thisRow.shares) { thisRow.shares = 0 }
    var parts = thisRow.date.split('/');
    var newDateStr = `${parts[2]}-${parts[1]}-${parts[0]}`;
    thisRow.date = newDateStr
    if (checkRow(thisRow, index)) {
      moondanceApi.addNewTransaction(thisRow).then(response => {
        if (response.success) {
          addAlert({
            status: 'success',
            title: 'Add Transaction',
            message: 'A transaction has been added to position ' + thisRow.position_id + ' !'
          })
          handle_form_change('_edit_status', index, 'saved')
          setLastUpdate(timestamp)
        } else {
          console.log('response', response)
          addAlert({
            status: 'danger',
            title: 'Add Transaction Failed  position ' + thisRow.position_id + ' !',
            message: (response.error ? response.error : 'An error occured')
          })
          response.successMessage = 'This transaction has  NOT been successfully added !'

        }
      })
        .catch(error => {
          addAlert({
            status: 'danger',
            title: 'Add Transaction Failed  position ' + thisRow.position_id + ' !',
            message: error
          })

        });
    }
  }


  //SAVE PART
  function saveAllRows() {

    formData.map((row, index) => {
      if (row._valid && !row._duplicate) {
        if (importType === 'transaction') {
          saveTransactionRow(row, index)
        } else if (importType === 'position') {
          savePositionRow(row, index)
        } else if (importType === 'nav') {
          saveNavRow(row, index)
        }
      }
    })

  }
  async function saveAsset(asset) {
    try {
      const response = await moondanceApi.createAsset(asset);
      if (response.success) {
        console.log('response', response);
        return response.id;
      } else {
        throw new Error('Asset creation failed');
      }
    } catch (error) {
      addAlert({
        status: 'danger',
        title: 'Add Asset Failed !',
        message: error.message || error,
      });
      return false;
    }
  }
  async function savePosition(position) {
    try {
      const response = await moondanceApi.addNewPosition(position);
      if (response.success) {
        console.log('response', response);
        return response.id;
      } else {
        throw new Error('Position creation failed');
      }
    } catch (error) {
      addAlert({
        status: 'danger',
        title: 'Add position Failed !',
        message: error.message || error,
      });
      return false;
    }
  }

  async function savePositionRow(thisRow, index) {
    console.log('savePositionRow', thisRow, index)  
    
    if (!thisRow.shares) { thisRow.shares = 0 }

    var parts = thisRow.inception_date.split('/');
    var newDateStr = `${parts[2]}-${parts[1]}-${parts[0]}`;
    thisRow.inception_date = newDateStr

     var parts = thisRow.subscription_date.split('/');
    var newDateStr = `${parts[2]}-${parts[1]}-${parts[0]}`;
    thisRow.subscription_date = newDateStr
    

    
    if (checkRow(thisRow, index)) {

      let newAsset = {
        asset_account_id: selectedAccount,
        asset_currency: thisRow.currency,
        asset_description:(thisRow.description ? thisRow.description : ""),
        asset_detention_period:(thisRow.detention_period ? thisRow.detention_period: 5),
        asset_emitter: (thisRow.emitter ? thisRow.emitter : ""),
        asset_expected_drawdown:(thisRow.expected_drawdown ? thisRow.expected_drawdown : 1),
        asset_expected_irr:(thisRow.expected_irr ? thisRow.expected_irr : 0.1),
        asset_expected_tvpi: (thisRow.expected_tvpi ? thisRow.expected_tvpi : 1.5),
        asset_feeder_name: (thisRow.asset_feeder_name ? thisRow.asset_feeder_name : ""),
        asset_feeder_type: (thisRow.asset_feeder_type ? thisRow.asset_feeder_type : ""), 
        asset_inception_date:(thisRow.inception_date ? thisRow.inception_date : ""),
        asset_intermediate: (thisRow.intermediate ? thisRow.intermediate : ""),
        asset_investment_period: (thisRow.investment_period ? thisRow.investment_period : 5),
        asset_name: (thisRow.name ? thisRow.name : ""),
        
        asset_status:  (thisRow.status && thisRow.status  == parseInt(thisRow.status ) ? parseInt(thisRow.status) : 1),
        asset_vintage_year: (thisRow.vintage_year ? thisRow.vintage_year :  MoondanceLayout.currentYear()),
        asset_model_capitalcall: [-20, -20, -20, -20, -20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        asset_model_distribution:  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        //add asset model  (call + distribution)
        //handle asset type / sector / geo
      }
      console.log('newAsset', thisRow,newAsset)
      let asset_id = await saveAsset(newAsset);
      if(!asset_id){
        return false
      } else {
        let newPosition = {
          position_commitment: (thisRow.commitment ? thisRow.commitment : 1),  
          position_account_id: selectedAccount,
          position_asset_id:asset_id,
          position_subscription_date: (thisRow.subscription_date ? thisRow.subscription_date : ""),
          position_shares : (thisRow.shares ? thisRow.shares : 0),
          position_status : (thisRow.status && thisRow.status  == parseInt(thisRow.status ) ? parseInt(thisRow.status) : 1)         
        }
        console.log('newPosition', newPosition)
        let position_id = await savePosition(newPosition);
        if(!position_id){
          return false
        } else {
          addAlert({
            status: 'success',
            title: 'Add Position',
            message: 'A position has been added to account ' + selectedAccount + ' !'
          })
          handle_form_change('_edit_status', index, 'saved')
          setLastUpdate(timestamp)
        }

    console.log('saved PositionRow', thisRow, index)  
      }
      /*
       
          if(response && response.id){
            thisRow.asset_id = response.id
            let newPosition = {
              position_commitment: (thisRow.position_commitment ? thisRow.position_commitment : 1),  
              position_account_id: selectedAccount,
              position_asset_id: thisRow.asset_id,
              position_subscription_date: (thisRow.subscription_date ? thisRow.subscription_date : ""),
              position_shares : (thisRow.shares ? thisRow.shares : 0),
              position_status : (thisRow.status && thisRow.status  == parseInt(thisRow.status ) ? parseInt(thisRow.status) : 1)         
            }
            console.log('newPosition', newPosition)

            /* moondanceApi.createPosition(newPosition).then(response_position => {
              if (response_position.success) {
                console.log('response_position', response_position)
              addAlert({
                  status: 'success',
                  title: 'Add Position',
                  message: 'A position has been added to account ' + selectedAccount + ' !'
                })
              } else {
                console.log('response_position', response_position)
                addAlert({
                  status: 'danger',
                  title: 'Add Position Failed  position ' + thisRow.position_id + ' !',
                  message: (response_position.error ? response_position.error : 'An error occured')
                })
       
              }
            });  
          }
          
        } else {
          console.log('response', response)
          addAlert({
            status: 'danger',
            title: 'Add Position Failed  position ' + thisRow.position_id + ' !',
            message: (response.error ? response.error : 'An error occured')
          })
         
        }
        */
     
    }

  }





  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true} style={{ paddingBottom: '30em' }}>
          <h1>Import Data from Excel File</h1>

          <Row>
            <Form.Group as={Col} md={4} className="mb-3">
              <Form.Label >Select the account destination :</Form.Label>
              <Select
                onChange={(e) => {
                  setSelectedAccount(e.value)
                }}
                value={accountList && accountList.find(item => item.value === selectedAccount)}
                placeholder="Select Account"
                formatOptionLabel={formatOptionLabel}
                styles={MoondanceLayout.select2customStyles}
                style={{ zIndex: 9999 }}
                options={accountList}
                classNamePrefix="select2-selection"
              />
            </Form.Group>
            <Form.Group as={Col} md={4} className="mb-3">
              <Form.Label >or create a new account </Form.Label>
              <Row>
                <Col md="8">
                  <input type="text" className="form-control "
                    defaultValue={newAccountName}
                    onChange={e => setNewAccountName(e.target.value)}
                    placeholder="Account name"
                    id="newAccountName"
                  />
                </Col>
                <Col md="4">
                  <Button className="btn btn-outline-secondary " onClick={() => { createNewAccount() }}><i className="fas fa-edit"></i>{" "}Save</Button>
                </Col>
              </Row>


            </Form.Group>
            <p>Please note that, depending on your subscription, creating a new account may trigger an upgrade and result in additional charges.</p>

          </Row>
          {selectedAccount ?
            <Form.Group as={Col} className="mb-3">

              <Form.Label >Select the type of data to import</Form.Label>
              <select
                className="form-control"
                style={MoondanceLayout.select2customStyles}
                onChange={(e) => setImportType(e.target.value)}
                value={importType} // This ensures the selected option matches the state
              >
                {importTypeList.map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.label}
                  </option>
                ))}
              </select>
              {((!showGuidelines && importType) ? <button className="btn btn-sm btn-link" onClick={() => { setShowGuidelines(true) }}>Show Guidelines</button> : '')}
              <br />
              {(() => {
                const selectedType = importTypeList.find(item => item.id === importType);
                if (showGuidelines && selectedType && selectedType.keys) {
                  return (
                    <>
                      <p>The following are needed to import these data, data should be organized in columns with the first row being the name of the variable:</p>
                      <ul>
                        {Object.entries(selectedType.keys).map(([key, item], index) => (
                          <li key={index}>
                            <strong>{item.label} </strong>:
                            <br />{item.explanation}
                            <br />Accepted labels : {key} ,{item.alternate.join(', ')}
                          </li>
                        ))}
                      </ul>
                      <button className="btn btn-sm btn-link" onClick={() => { setShowGuidelines(false) }}>Hide Guidelines</button>
                    </>
                  );
                }

                return null;
              })()}
            </Form.Group>
            : null}
          <div>
            <hr />


          </div>

          {(selectedAccount && importType) ?
            <Form.Group as={Col} className="mb-3">

              <Form.Label >Import File</Form.Label>

              {fileName ? (
                <p>File Selected: <b>{fileName}</b>
                  <button style={{ marginLeft: '1em' }} className="btn btn-sm btn-outline-primary" onClick={handleButtonClick}>Select Another File</button>
                </p>
              ) :
                <><br /><button className="btn btn-outline-primary" onClick={handleButtonClick}>Select file to import (.xls or .csv)</button></>
              }
              <input
                type="file"
                id="fileInput"
                onChange={handleFileChange}
                accept=".xls,.xlsx"
                style={{ display: 'none' }}
              />
            </Form.Group>
            : null}
          <Form.Group as={Col} className="mb-3">
            {sheetNames.length > 0 && (
              <>
                <p className="mt-0 card-title">{(sheetNames.length == 1 && selectedSheet) ? <>Active sheet : {sheetNames}</> : <>Select the active sheet</>}</p>

                {(sheetNames.length > 0) ?
                  <Select
                    styles={MoondanceLayout.select2customStyles}
                    value={sheetNames[selectedSheet]}
                    onChange={(e) => handleSheetSelection(e.value)}
                    options={(sheetNames ? sheetNames.map((name, index) => ({ value: index, label: name })) : [])}
                  />
                  : null}
              </>
            )}

          </Form.Group>

          {(selectedSheet && jsonData && jsonData.length > 0 && keyMap) ?
            <div>
              <br />
              <hr />
              <h6>We found the following data in your file :</h6>
              <table key='formTable' style={{ minWidth: '100%', overflow: 'scroll', fontSize: '0.8em' }}>
                <tbody>
                  {jsonData.map((row, index) => {

                    if (index < 5 || (jsonData && index > jsonData.length - 5) || showCsvFull) {
                      return (
                        <tr key={index}>
                          {
                            // Ensure each cellIndex gets rendered, even if some cells are missing
                            Array.from({ length: jsonData[0].length }).map((_, cellIndex) => {
                              const cell = row[cellIndex]; // Get the cell at the current index, or undefined if missing

                              return (
                                <td key={cellIndex} style={{ padding: '0.2em', border: '1px solid #ccc', textAlign: 'center' }}>
                                  {(index == 0 ?
                                    (keyMap && keyMap._found && keyMap._found[cellIndex])
                                      ? <span className="mdi mdi-check-circle" style={{ color: MoondanceLayout.colorScheme.success }}></span>
                                      : <span className="mdi mdi-alert-circle" style={{ color: MoondanceLayout.colorScheme.danger }}></span>
                                    : '')
                                  } {/* Render the cell content, or empty if missing */}
                                  {cell || ''} {/* Render the cell content, or empty if missing */}
                                </td>
                              );
                            })
                          }

                        </tr>
                      )
                    } if (index == 6 && !showCsvFull) {
                      return (<tr key='showAll'><td colSpan="9"><button className="btn btn-sm btn-link" onClick={() => { setShowCsvFull(true) }}> ... Show all</button></td></tr>
                      )
                    }
                  })}
                </tbody>
              </table>
              <p> <span className="mdi mdi-check-circle" style={{ color: MoondanceLayout.colorScheme.success }}></span> Match requested keys <br /><span className="mdi mdi-alert-circle" style={{ color: MoondanceLayout.colorScheme.danger }}></span> Doesn't match requested keys</p>

              {(showCsvFull ? <button className="btn btn-sm btn-link" onClick={() => { setShowCsvFull(false) }}> ... Show less</button> : '')}
            </div>
            : ''}



          {(missingKeys && missingKeys.length > 0) ?
            <Card className="alert-light card border" style={{ marginTop: '1em' }}>
              <CardTitle className="card-header bg-danger-subtle"><span className="mdi mdi-alert"></span> Missing keys</CardTitle>
              <CardBody className="card-body alert-light ">

                <p>Some required keys are missing from your file. Please review the following keys :</p>
                <ul>
                  {missingKeys.map((item, index) => (
                    <li key={index}>
                      <strong>{item.key}</strong>: {item.explanation}
                    </li>
                  ))}
                </ul>
                <p>Please ensure you have selected the correct Excel file and the appropriate sheet.<br /></p>


              </CardBody>
            </Card>
            : null}



          <div> {aiReturnedComment}
          </div>
          {(showForm && formData.length > 0) ?
            <div style={{ marginTop: '2em' }}>
              <hr />
              <h6>Imported Data :</h6>
              <p>Please validate the following results :</p>
              <table style={{ borderCollapse: "collapse", fontSize: '0.9em', lineHeight: '0.9em', overflow: 'scroll', minWidth: '100%' }}>
                <thead>
                  <tr>
                    {Object.values(formKeys).filter((key) => String(key).charAt(0) !== "_").map((key) => (
                      <th key={key.label} style={(key.formStyle ? key.formStyle : { minWidth: '12em', maxWidth: '14em' })}>
                        {key.label}
                      </th>
                    ))}
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.map((item, index) => {

                    return ((!item._duplicate || (item._duplicate && showDuplicate)) ?
                      <tr key={index} >

                        {Object.keys(item)
                          .filter((key) => String(key).charAt(0) !== "_") // Convert key to string & check first character
                          .map((key) => (
                            <td key={key}>
                              <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
                                {(formKeys && formKeys[key] && formKeys[key].options ?
                                  <>
                                    <Select
                                      value={item[key] ? formKeys[key].options.find(option => option.id === item[key]) : (formKeys[key].default ? formKeys[key].options.find(option => option.id === formKeys[key].default) : null)}
                                      onChange={(f) => { handle_form_change(key, index, f); }}
                                      options={formKeys[key].options}
                                      formatOptionLabel={formatOptionLabel}
                                      style={{ fontSize: '1em', minWidth: '4em', maxWidth: '3em' }}
                                      styles={MoondanceLayout.select2customStyles}


                                    />
                                  </>
                                  :
                                  <input
                                    value={item[key]}
                                    className="form-control"
                                    type="text"
                                    style={{
                                      fontSize: "1em",
                                      padding: "9px",
                                      paddingRight: item._invalidKeys && item._invalidKeys[key] ? "30px" : "9px", // Space for the icon
                                      ...(item._invalidKeys && item._invalidKeys[key] ? { borderColor: "red" } : {}),
                                    }}
                                    onChange={(f) => handle_form_change(key, index, f.target.value)}
                                  />
                                )}
                                {item._invalidKeys && item._invalidKeys[key] && (
                                  <span
                                    className="mdi mdi-alert-circle"
                                    style={{
                                      color: MoondanceLayout.colorScheme.danger,
                                      position: "absolute",
                                      right: "10px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      fontSize: "1.2em",
                                      pointerEvents: "none", // Prevents blocking input interaction
                                    }}
                                  ></span>
                                )}
                              </div>
                            </td>

                          ))}



                        <td >
                          {(item._edit_status == 'saved' ?
                            <button style={{ width: '10em' }} className="btn btn-sm btn-outline-success" >Saved !</button>
                            :
                            (item._duplicate ?
                              <button style={{ width: '10em' }} className="btn btn-sm btn-outline-warning" >Duplicate</button>
                              :
                              (item._valid ?
                                <button style={{ width: '10em' }}
                                  className="btn btn-sm btn-success"
                                  onClick={() => saveRow(item, index)}>Save</button>
                                :
                                <button style={{ width: '10em' }} className="btn btn-sm btn-outline-danger" >Invalid Data</button>
                              )
                            )
                          )}
                        </td>

                      </tr> : null
                    )
                  }
                  )}

                </tbody>
                <tfoot
                  style={{ display: "table-header-group" }}
                >
                  <tr>
                    <td colSpan={Object.keys(formKeys).length}>

                      {(showDuplicate ? <button className="btn btn-sm btn-link" onClick={() => { setShowDuplicate(false) }}>Hide Duplicate</button> : <button className="btn btn-sm btn-link" onClick={() => { setShowDuplicate(true) }}>Show Duplicate</button>)}
                    </td>
                    <td>
                      <button style={{ width: '10em' }}
                        className="btn btn-sm btn-warning"
                        onClick={() => saveAllRows()}
                      >
                        Save All
                      </button>
                    </td>
                  </tr>
                </tfoot>
              </table>

            </div>
            : null}


        </Container>
      </div>
      <div>
        <button className="btn  btn-sm btn-link" style={{ marginRight: '0.5em' }} onClick={() => { testWithDummyData() }}><i className="mdi mdi-robot"></i> test with dummy data</button>
      </div>
      {aiPrompt}
    </React.Fragment >
  );
}

export default ImportXls;

/*


          {(showTransactionForm && importType == 'transaction' && newTransactionList.length > 0) ?
            <div style={{ marginTop: '2em' }}>
              <hr />
              <h6>Transaction List</h6>
              <p>Please validate the following results :</p>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: '0.9em', lineHeight: '0.9em' }}>
                <thead>
                  <tr>
                    <th style={{ minWidth: '12em', maxWidth: '14em' }}>Position</th>
                    <th style={{ minWidth: '8em', maxWidth: '8em' }}>Date</th>
                    <th style={{ minWidth: '8em', maxWidth: '8em' }}>Type</th>
                    <th style={{ minWidth: '4em', maxWidth: '2em' }}>Shares</th>
                    <th style={{ minWidth: '8em', maxWidth: '8em' }}>Total Amount</th>
                    <th style={{ minWidth: '7em', maxWidth: '7em' }}>Currency</th>
                    <th style={{ minWidth: '3em', maxWidth: '3em' }}>Bank</th>
                    <th style={{ minWidth: '10em', maxWidth: '10em' }}>Description</th>
                    <th style={{ minWidth: '8em', maxWidth: '8em' }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {newTransactionList.map
                    ((item, index) => {
                      return ((!item._duplicate || (item._duplicate && showDuplicate)) ?
                        <tr key={index} >
                          <td style={{ minWidth: '12em', maxWidth: '12em' }}>
                            <Select
                              id="floatingSelectFund"
                              value={item.position_id && positionList ?
                                positionList.flatMap(group => group.options).find(option => option.value === parseInt(item.position_id))
                                : null}
                              onChange={(f) => { handle_form_change('position_id', index, f.value); }}
                              placeholder={'Not FOUND :' + item.positionName}
                              options={positionList}
                              formatOptionLabel={formatOptionLabel}
                              formatGroupLabel={formatGroupLabel}
                              styles={MoondanceLayout.select2customStyles}
                              style={{ fontSize: '0.9em', lineHeight: '0.9em' }}
                            />
                          </td>
                          <td style={{ minWidth: '6em', maxWidth: '6em' }}>

                            <input
                              value={item.date}
                              className="form-control"
                              type="text"
                              style={{ fontSize: '1em', padding: '9px', }}

                              onChange={(f) => { handle_form_change('date', index, f.target.value); }}
                            ></input>



                          </td>
                          <td >
                            <Select
                              id="add_transaction_type"
                              value={transactionTypeList.find(option => option.value === item.type)}
                              onChange={(f) => { handle_form_change('type', index, f); }}
                              options={transactionTypeList}
                              formatOptionLabel={formatOptionLabel}
                              style={{ fontSize: '1em', minWidth: '4em', maxWidth: '3em' }}

                              styles={MoondanceLayout.select2customStyles}

                            />
                          </td>

                          <td style={{ minWidth: '4em', maxWidth: '4em' }}><input
                            value={item.shares}
                            className="form-control"
                            type="number"
                            style={{ fontSize: '1em', padding: '9px', }}

                            onChange={(f) => { handle_form_change('shares', index, f.target.value); }}
                          ></input></td>
                          <td style={{ minWidth: '8em', maxWidth: '8em' }}><input
                            value={item.value}
                            className="form-control"
                            type="number"
                            onChange={(f) => { handle_form_change('value', index, f.target.value); }}
                            style={{ fontSize: '1em', padding: '9px', }}

                          ></input></td>
                          <td style={{ minWidth: '4em', maxWidth: '4em' }}>
                            <Select
                              onChange={(e) => { handle_form_change('currency', index, e); }}
                              formatOptionLabel={formatOptionLabel}

                              styles={MoondanceLayout.select2customStyles}
                              value={currencyList.find(option => option.id === item.currency)}
                              options={currencyList}
                            />
                          </td>
                          <td style={{ minWidth: '8em', maxWidth: '8em' }}>
                            <input
                              value={item.bank}
                              className="form-control"
                              type="text"
                              style={{ fontSize: '1em', padding: '9px', }}

                              onChange={(f) => { handle_form_change('bank', index, f.target.value); }}
                            ></input></td>
                          <td >
                            <input
                              value={item.note}
                              className="form-control"
                              type="text"
                              onChange={(f) => { handle_form_change('note', index, f.target.value); }}
                            ></input></td>
                          <td >{item._duplicate ? <button style={{ width: '10em' }} className="btn btn-sm btn-outline-warning" >Duplicate</button> : ''}
                            {(item._valid && item.edit_status !== 'saved' && !item._duplicate ? <button style={{ width: '10em' }} className="btn btn-sm btn-success" onClick={() => { saveTransactionRow(item, index) }}>Save</button> : '')}
                            {(item._valid && item.edit_status == 'saved' ? <button style={{ width: '10em' }} className="btn btn-sm btn-link" >Saved !</button> : '')}
                            {(!item._valid ? <button style={{ width: '10em' }} className="btn btn-sm btn-outline-danger" >Missing Data</button> : '')}

                          </td>
                        </tr> : '')
                    }
                    )
                  }
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="8">
                      <p style={{ fontSize: '1em' }}><span className="mdi mdi-alert-circle" style={{ color: MoondanceLayout.colorScheme.danger }}></span> Duplicate records are {(showDuplicate ? '' : 'not')} displayed, <button className={(showDuplicate ? "btn btn-sm btn-outline-danger" : "btn btn-sm btn-danger")} onClick={() => { setShowDuplicate(!showDuplicate) }} >{(showDuplicate ? <>Hide Duplicate</> : <>Show Duplicate</>)}</button></p>
                    </td>
                    <td><button style={{ width: '10em' }} className="btn btn-sm btn-warning" onClick={() => { saveAllTransactionRow() }}>Save All valid items </button> </td>
                  </tr>

                </tfoot>
              </table>

            </div>

            : ''}
      It is important that your reply be formated as a JSON object as described below, 
      without any other comment, ensuring all numeric values are formatted with two decimals and all data adhere to the defined structure.
     
      Output Format Specification:
      
      {
        "data": [
          {
            "date": "DD/MM/YYYY",
            "type": "transaction type or null",
            "amount": "numeric value with 2 decimals",
            "description": "transaction description",
            "shares": "number of shares or 0",
            "currency": "transaction currency",
            "positionName": "name of the asset",
            "comment": "confidence level of your analysis (integer value from 0 to 10)",
            "position_id": "ID of the position if found in data.positions"
          }
        ],
        "comment": "General comment about the analysis of the file and data, tips on how to improve te analysis, the source file etc..."
      }
 Reply :     
{
    "success": true,
    "data": {
      "content": "```json\n[\n  {\"date\":\"15/01/2025\",\"type\":null,\"amount\":\"-225.10\",\"description\":\"Frais de Private Banking\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":null,\"comment\":5,\"positionId\":null,\"bank\":null},\n  {\"date\":\"15/01/2025\",\"type\":null,\"amount\":\"-440.85\",\"description\":\"Commission de conseil\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":null,\"comment\":5,\"positionId\":null,\"bank\":null},\n  {\"date\":\"31/12/2024\",\"type\":null,\"amount\":\"69.77\",\"description\":\"Intérêts créditeurs\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":null,\"comment\":5,\"positionId\":null,\"bank\":null},\n  {\"date\":\"31/12/2024\",\"type\":null,\"amount\":\"-20.93\",\"description\":\"Précompte mobilier\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":null,\"comment\":5,\"positionId\":null,\"bank\":null},\n  {\"date\":\"30/12/2024\",\"type\":\"Distribution\",\"amount\":\"216.58\",\"description\":\"Distribution DIV ZEPHYR'07 PRIV EQ CO\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":\"Swancap - Zephyr 07 Priv EQ OPP A\",\"comment\":8,\"positionId\":7,\"bank\":null},\n  {\"date\":\"30/12/2024\",\"type\":\"Distribution\",\"amount\":\"8229.75\",\"description\":\"Distribution CAP ZEPHYR'07 PRIV EQ CO\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":\"Swancap - Zephyr 07 Priv EQ OPP A\",\"comment\":8,\"positionId\":7,\"bank\":null},\n  {\"date\":\"30/12/2024\",\"type\":\"Distribution\",\"amount\":\"4640.23\",\"description\":\"Distribution CAD ZEPHYR'07 PRIV EQ CO\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":\"Swancap - Zephyr 07 Priv EQ OPP A\",\"comment\":8,\"positionId\":7,\"bank\":null},\n  {\"date\":\"30/12/2024\",\"type\":\"Fees\",\"amount\":\"-95.80\",\"description\":\"Management Fees ZEPHYR'07 PRIV EQ COM\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":\"Swancap - Zephyr 07 Priv EQ OPP A\",\"comment\":8,\"positionId\":7,\"bank\":null},\n  {\"date\":\"30/12/2024\",\"type\":\"Capital Call\",\"amount\":\"-293.18\",\"description\":\"Capital Call ZEPHYR'07 PRIV EQ COMMIT\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":\"Swancap - Zephyr 07 Priv EQ OPP A\",\"comment\":8,\"positionId\":7,\"bank\":null},\n  {\"date\":\"30/12/2024\",\"type\":\"Capital Call\",\"amount\":\"-3447.90\",\"description\":\"Capital Call ZEPHYR'07 PRIV EQ COMMIT\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":\"Swancap - Zephyr 07 Priv EQ OPP A\",\"comment\":8,\"positionId\":7,\"bank\":null},\n  {\"date\":\"29/11/2024\",\"type\":null,\"amount\":\"-69.77\",\"description\":\"Ext. int courus au 30/11/24\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":null,\"comment\":5,\"positionId\":null,\"bank\":null},\n  {\"date\":\"29/11/2024\",\"type\":null,\"amount\":\"69.77\",\"description\":\"Int courus au 30/11/24\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":null,\"comment\":5,\"positionId\":null,\"bank\":null},\n  {\"date\":\"08/11/2024\",\"type\":null,\"amount\":\"-105000.00\",\"description\":\"Virement à B0120950\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":null,\"comment\":5,\"positionId\":null,\"bank\":\"B0120950\"},\n  {\"date\":\"31/10/2024\",\"type\":null,\"amount\":\"-32.56\",\"description\":\"Ext. int courus au 31/10/24\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":null,\"comment\":5,\"positionId\":null,\"bank\":null},\n  {\"date\":\"31/10/2024\",\"type\":null,\"amount\":\"32.56\",\"description\":\"Int courus au 31/10/24\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":null,\"comment\":5,\"positionId\":null,\"bank\":null},\n  {\"date\":\"14/10/2024\",\"type\":null,\"amount\":\"-262.98\",\"description\":\"Frais de Private Banking\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":null,\"comment\":5,\"positionId\":null,\"bank\":null},\n  {\"date\":\"14/10/2024\",\"type\":null,\"amount\":\"-543.79\",\"description\":\"Commission de conseil\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":null,\"comment\":5,\"positionId\":null,\"bank\":null},\n  {\"date\":\"30/09/2024\",\"type\":\"Distribution\",\"amount\":\"105221.90\",\"description\":\"Rbt 300 PARTNERS GRP GL VAL R EUR\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":\"Partner group\",\"comment\":9,\"positionId\":138,\"bank\":null},\n  {\"date\":\"27/08/2024\",\"type\":\"Distribution\",\"amount\":\"105.18\",\"description\":\"Distribution DIV ZEPHYR'07 PRIV EQ CO\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":\"Swancap - Zephyr 07 Priv EQ OPP A\",\"comment\":8,\"positionId\":7,\"bank\":null},\n  {\"date\":\"27/08/2024\",\"type\":\"Distribution\",\"amount\":\"4363.06\",\"description\":\"Distribution CAD ZEPHYR'07 PRIV EQ CO\",\"shares\":0,\"currency\":\"EUR\",\"positionName\":\"Swancap - Zephyr 07 Priv EQ OPP A\",\"comment\":8,\"positionId\":7,\"bank\":null}\n]\n```",
      "refusal": null,
      "role": "assistant",
      "audio": null,
      "function_call": null,
      "tool_calls": null
  },
  "nt": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiZW1haWwiOiJndXkuY291cGV6QHByb3Rvbm1haWwuY29tIiwicGhvbmUiOiIzMjQ3NjU3MjY4OSIsImV4cCI6MTczODQzNTA5MCwidGltZXN0YW1wIjoxNzM4NDM1MDkwLCJzYWx0IjoieGkwOTNueHl5N3h6Z3VtZzJ3M3g3MWswIn0.xQg5g9rRawbT5rL0sxnTx0o5k-5QMmDT2lK3P8bWvG8"
}
  <button
                  className="btn  btn-outline-info"
                  style={{ marginRight: '0.5em' }}
                  onClick={() => {

                    setShowForm(!showForm)

                  }}>
                  {
                    (showForm ?
                      <><i className="mdi mdi-pause"></i>Hide results</>
                      : <><i className="mdi mdi-play"></i> Show result anyway </>
                    )}
                </button>
                <p style={{ marginTop: '1.5em' }} ><b>Disclaimer:</b><br />By using AI to analyze your XLS file, you acknowledge and accept that your data may be sent to external AI services, such as OpenAI, for processing and analysis. We take reasonable measures to protect your data, but we cannot guarantee full confidentiality due to the nature of third-party service integration. Use this feature at your discretion.</p>



                <br /><div style={{ marginTop: '1em' }}  >{aiLoading}</div>
 <p>
                <br />Alternatively, you can use our AI tool to automatically match the fields in your file with the required fields.</p>
                <br />
                <button className="btn  btn-info" style={{ marginRight: '0.5em' }} onClick={() => { analyse_ai() }}><i className="mdi mdi-robot"></i> Analyse trough OpenAI</button>
               

      */